// ハンバーガーメニュー内リンククリック時に、ハンバーガーメニューを閉じる
document.querySelectorAll('.menu-drawer__menu-item').forEach(item => {
    item.addEventListener('click', () => {
        const closeButton = document.querySelector('.menu-drawer-container.menu-opening .header__icon.link');
      console.log(closeButton);
        if (closeButton) {
            closeButton.click();
        }
    });
});
